import { useContext, useEffect, useState } from "react"

import { useSelector, useDispatch } from "react-redux"
import { Dispatch } from "redux"
import * as actions from './../../../shared/StoreContainer/actionCreators';

import { UserContext, Config } from "../../../App"
import { sendMetricAction } from "../../../shared/MetricApi"

import Exit from '../../../shared/icons/exitCross.svg'
import Doc from '../../../shared/icons/docImage.svg'
import classNames from "./styles.module.scss"

interface InfoField {
  name: string,
  num: number | string,
  unit: string | Function | undefined,
  className: string | null | undefined,
  style: any | null | undefined,
  needButton?: boolean,
  secondPath?: string,
  originalId?: string
}

interface PropertyStructure {
  name: string,
  field: string | Function,
  unit?: string | Function,
  divisor?: number,
  round?: number,
  longText?: boolean,
  style?: any,
  needButton?: boolean,
  originalId?: string
}

export const FeatureInfo = () => {
  const dispatch: Dispatch<any> = useDispatch();
  //@ts-ignore
  const objectClickContainer = useSelector((state) => (state?.containerObjectClick));
  //@ts-ignore
  const layersContainer = useSelector((state) => (state?.containerLayers));

  const [infoArray, SetInfoArray] = useState<Array<InfoField> | undefined>();
  const [territoryName, SetTerritoryName] = useState<string>('');
  const [header, SetHeader] = useState<string>('');
  const [subHeader, SetSubHeader] = useState<string>('');
  const [opened, SetOpened] = useState<boolean>(false);
  const [openedMoreArray, setOpenedMoreArray] = useState<Array<{ id: string, open: boolean }> | null>(null);

  const id = useContext(UserContext).id;

  const needFirstPart = (id: string): boolean => {
    return id === "type21extraTax"
      || id === "type21roomsExtraTax"
      || id === "type22extraTax"
      || id === "type22roomsExtraTax"
      || id === "type23extraTax"
      || id === "type23roomsExtraTax"
      || id === "type24extraTax"
      || id === "type24roomsExtraTax"
      || id === "type25extraTax"
      || id === "type25roomsExtraTax"
      || id === "type26extraTax"
      || id === "type26roomsExtraTax"
  }

  const buttonShowMoreHandler = (id: string) => {
    if (openedMoreArray) {
      let copy = JSON.parse(JSON.stringify(openedMoreArray));
      const elem = copy.find((e: { id: string, open: boolean }) => e.id === id);
      elem.open = !elem.open;
      setOpenedMoreArray(copy);
    }
  }

  const checkNeedShowMore = (id: string): boolean => {
    if (openedMoreArray) {
      return Boolean(openedMoreArray.find(e => e.id === id)?.open)
    }
    return false;
  }

  useEffect(() => {
    SetOpened(objectClickContainer.feature ? true : false)
  }, [objectClickContainer])

  useEffect(() => {
    document.getElementById('infoFeatureContainer') && (document.getElementById('infoFeatureContainer')!.className = classNames.infoContainer + ' ' + (opened ? classNames.opened : ''))
  }, [opened])

  useEffect(() => {
    let properties = objectClickContainer.feature?.getGeometry()?.getProperties()
    let array: Array<InfoField> = [];
    let openedMore: Array<{ id: string, open: boolean }> = []

    console.log(properties);

    if (properties) {
      SetTerritoryName(Config.featureInfo.territoryNameFunc(properties))
      SetHeader(Config.featureInfo.headerFunc(properties))
      SetSubHeader(Config.featureInfo.subHeaderFunc(properties))

      let propertyStructure: Array<PropertyStructure> = Config.featureInfo.properties;
      propertyStructure.forEach(property => {
        const isRegionLayer = layersContainer.layers.find((l: any) => l.turned).id === "regions";
        let moreOptions = {}

        let value = (typeof property.field === 'function')
          ? property.field(
            properties,
            isRegionLayer,
            {
              main: classNames.infoText__moreInfo,
              unit: classNames.unitText
            },
            needFirstPart(property?.originalId ?? "")
          )
          :
          properties[property.field] ?
            (properties[property.field] / (property.divisor || 1)).toFixed(property.round || 0) : null;

        if (value && property.longText) {
          value = '' + value;
          if (value.length > 150) value = value.substring(0, 150) + '...';
        }

        if (needFirstPart(property?.originalId ?? "") && typeof property.field === 'function') {
          Object.assign(moreOptions, {
            needButton: property.needButton,
            secondPath: property.field(properties, isRegionLayer, { main: classNames.infoText__moreInfo, unit: '' }, false),
            originalId: property.originalId
          })

          openedMore.push({
            id: property.originalId ?? '',
            open: false
          })
        }


        let unitValue = (typeof property.unit === 'function') ? property.unit(properties) : property.unit;
        if (value) {
          array.push(
            {
              name: property.name,
              num: value,
              unit: unitValue,
              style: property.style,
              className: property.longText ? classNames.infoTextLongString : undefined,
              ...moreOptions
            }
          )
        }
      })
      SetInfoArray(array)
      setOpenedMoreArray(openedMore);
    }
    //eslint-disable-next-line
  }, [objectClickContainer])

  return <>
    {<div id='infoFeatureContainer' className={classNames.infoContainer + (objectClickContainer.feature ? ' ' + classNames.opened : '')}>
      {
        header && <div className={classNames.titleContainer}>
          <div className={classNames.cityElement}>
            <p className={classNames.cityTitle}>{header}</p>
            <p className={classNames.cityTitleBottom}>{subHeader}</p>
          </div>
          <div className={classNames.infoButtons}>
            <p onClick={() => {
              actions.complexActionForContact(dispatch, true, territoryName);
              id && sendMetricAction(id, 'saveButtonClick', territoryName)
            }}
            //@ts-ignore
              className={classNames.save}>{Config.texts.report.button}</p>
            <img className={classNames.exit} alt="close icon" src={Exit} onClick={() => SetOpened(false)} /></div>
        </div>
      }

      {infoArray?.map((line, i) => {
        return <div key={'line' + i} className={classNames.infoElement}>
          <p className={classNames.infoTitle}>{line.name}</p>
          <div className={classNames.flexDiv}>
            {line.needButton && <button className={classNames.infoText__button} onClick={() => buttonShowMoreHandler(line.originalId ?? '')} />}
            <p
              className={line.className || classNames.infoText}
              style={line.style}
              dangerouslySetInnerHTML={{ __html: line.originalId && checkNeedShowMore(line.originalId) ? `${line.num}${line.secondPath}` : `${line.num}` }} />
            {line.unit &&
              <p className={classNames.unitText}>{line.unit as string}</p>
            }
          </div>
          <img className={classNames.docIcon + ' ' + (opened ? '' : classNames.noneOpacity)} src={Doc} alt="decorate icon" />
        </div>
      })}
    </div>}
  </>
}